<template>
    <div class="animated fadeIn h-100">
    <gmap-map :center="center" :zoom="zoom" ref="mapa" map-type-id="roadmap" style="width: 100%; height: 100%">
      <gmap-cluster :grid-size="gridSize" v-if="clustering" v-on:click="clustering=false">
          <gmap-custom-marker :key="index" v-for="(m, index) in zones" :marker="m.position" :clickable="true" @click.native="openDevice(m)" :title="m.zonename" style="margin-top: 16px;"><div class="zoneMarker">{{m.count}}</div></gmap-custom-marker>
      </gmap-cluster>

      <gmap-custom-marker v-if="clustering==false" :key="index" v-for="(m, index) in zones" :marker="m.position" :clickable="true" @click.native="openDevice(m)" :title="m.zonename" style="margin-top: 16px;"><div class="zoneMarker">{{m.count}}</div></gmap-custom-marker>
    </gmap-map>
  </div>
</template>

<script>
import Vue from 'vue'
import VueSlider from 'vue-slider-component'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import 'vue-slider-component/theme/antd.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import { telemetry } from '@/api'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyD8vswyC9F9G4rpJnpfpgZAwL4J0C-FhO4',
    libraries: 'places'
  }
})

Vue.component('GmapCluster', GmapCluster)

export default {
  name: 'World',
  components: {
      'gmap-custom-marker': GmapCustomMarker,
      VueSlider,
      datePicker
  },
  data () {
    return {
      center: {lat: 48, lng: 18},
      zoom: 9,
      zones: [],
      currentMarker: 0,
      paths: [],
      pathsLoaded: [],
      InfoWindowShown: false,
      clustering: true,
      gridSize: 50
    }
  },
  computed: {
    path() {
        return this.$router.history.current.fullPath
    }
  },
  watch: {
    currentMarker: function(val){
      if(this.markers.length > 0 && this.pathsLoaded.length > val) {
          var selected = this.pathsLoaded[this.pathsLoaded.length - val - 1]
          this.markers[0] = {position: {lat: selected.lat, lng: selected.lng}, event: selected.event}
          this.paths = this.pathsLoaded.slice(this.pathsLoaded.length - val - 1)
          this.$refs.mapa.$mapPromise.then((map) => {
            map.panTo(this.markers[0].position)
          })
      }
    }
  },
  mounted () {
    this.updateMap()
  },
  methods: {
    openDevice(dev) {

    },
    formatDate(date) {
      return (new Date(date*1000)).toLocaleString()
    },
    updateMap() {
      this.$refs.mapa.$mapPromise.then(() => {
        telemetry.zoneCount().then(response => {
          if(response.data !== undefined) {
            var markers = []
            var bounds = new google.maps.LatLngBounds()
            for(var idx=0; idx < response.data.length; idx++) {
              if(response.data[idx].center != null && response.data[idx].area == false) {
                markers.push({'zoneid': response.data[idx].id, 'zonename': response.data[idx].name, 'position': response.data[idx].center, 'count': response.data[idx].count})
                bounds.extend(response.data[idx].center)
              }
            }
            this.zones = markers
            this.$refs.mapa.$mapObject.fitBounds(bounds)
          }
        }).catch((error) => {
          this.$toasted.error(error)
        })
      })
    }
  }
}
</script>
